module.exports = require('@hola.org/hls.js').default;
